import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@frontend/components/ui/card';
import { Separator } from '@frontend/components/ui/separator';
import { SettingsAdmins } from '@frontend/Settings/components/SettingsAdmins';
import { SettingsEditors } from '@frontend/Settings/components/SettingsEditors';

interface SettingsPermissionsProps {
  isReadOnly?: boolean;
}

export function SettingsPermissions({
  isReadOnly = false,
}: SettingsPermissionsProps) {
  return (
    <Card className="mt-12 max-w-[600px]">
      <CardHeader>
        <CardTitle>User Permissions</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="mt-5 flex flex-col gap-5">
          <Separator />
          <SettingsAdmins isReadOnly={isReadOnly} />
          <SettingsEditors isReadOnly={isReadOnly} />
        </div>
      </CardContent>
    </Card>
  );
}
